import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

export interface LinkedPatient {
  patient_id: number;
  patient_name: string;
  patient_display_name?: string;  // Custom display name set by the family member
  role: string;
  office_id: string;
  office_name?: string;  // Office name retrieved from backend
  relationship?: string;
  service_end_date?: string | null;  // YYYY-MM-DD JST. Messaging closes on the day after this date.
  // 本人連携時の読み取り専用表示用（patients テーブル由来、users とは独立）
  birth_date?: string | null;
  gender?: string | null;
}

/**
 * 連携している患者リストを取得するカスタムフック
 */
export const useLinkedPatients = () => {
  return useQuery({
    queryKey: ['linkedPatients'],
    queryFn: async () => {
      const data = await apiClient.getLinkedPatients();
      return data.patients;
    },
    // 認証済みの場合のみ有効化
    enabled: !!apiClient.getIdToken(),
  });
};

export default useLinkedPatients;
